(function(){
  var KEY='nliWishlistV1';
  var queued=false;
  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}}
  function write(v){localStorage.setItem(KEY,JSON.stringify(v))}
  function k(x){return x.handle||x.url}
  function sync(){
    var keys=read().map(k);
    document.querySelectorAll('.nli-card-wishlist').forEach(function(btn){
      var active=keys.indexOf(btn.dataset.handle)>-1;
      var pressed=active?'true':'false';
      var label=active?'Remove from wishlist':'Add to wishlist';
      var icon=active?'♥':'♡';
      if(btn.getAttribute('aria-pressed')!==pressed)btn.setAttribute('aria-pressed',pressed);
      if(btn.getAttribute('aria-label')!==label)btn.setAttribute('aria-label',label);
      if(btn.textContent!==icon)btn.textContent=icon;
    });
  }
  function categoryLabel(handle){
    if(handle.indexOf('chatbot')>-1)return 'Conversational AI';
    if(handle.indexOf('whatsapp')>-1)return 'Messaging AI';
    if(handle.indexOf('crm')>-1)return 'Sales & CRM';
    if(handle.indexOf('support')>-1)return 'Support AI';
    if(handle.indexOf('invoice')>-1)return 'Document Automation';
    if(handle.indexOf('document-data')>-1)return 'Document AI';
    if(handle.indexOf('appointment')>-1)return 'Scheduling AI';
    if(handle.indexOf('ecommerce')>-1)return 'Ecommerce AI';
    return 'AI Software';
  }
  function enhance(){
    document.querySelectorAll('.template-collection .card-wrapper,.template-search .card-wrapper').forEach(function(w){
      var a=w.querySelector('.card__heading a[href*="/products/"]');
      if(!a)return;
      var url=a.getAttribute('href')||'';
      var handle=(url.split('/products/')[1]||'').split('?')[0];
      var title=(a.textContent||'').trim();
      if(!handle)return;
      w.setAttribute('data-nli-handle',handle);

      var inner=w.querySelector('.card__inner')||w;
      var hasRealImage=!!inner.querySelector('.media img,.card__media img,img.motion-reduce');
      var placeholder=inner.querySelector('.nli-product-thumb');
      if(hasRealImage && placeholder)placeholder.remove();
      if(!hasRealImage && !placeholder){
        var thumb=document.createElement('div');
        thumb.className='nli-product-thumb';
        thumb.setAttribute('aria-hidden','true');
        thumb.innerHTML='<span>AI</span><i></i><i></i>';
        inner.prepend(thumb);
      }

      var info=w.querySelector('.card__information');
      if(info && !info.querySelector('.nli-card-kicker')){
        var kicker=document.createElement('span');
        kicker.className='nli-card-kicker';
        kicker.textContent=categoryLabel(handle);
        info.insertBefore(kicker,info.firstChild);
      }
      if(info && !info.querySelector('.nli-card-view')){
        var view=document.createElement('a');
        view.className='nli-card-view';
        view.href=url;
        view.textContent='View AI product';
        info.appendChild(view);
      }
      if(!w.querySelector('.nli-card-wishlist')){
        var price=(w.querySelector('.price')||{}).textContent||'';
        var b=document.createElement('button');
        b.type='button';
        b.className='nli-card-wishlist';
        b.dataset.handle=handle;
        b.dataset.title=title;
        b.dataset.url=url;
        b.dataset.price=price.trim();
        b.setAttribute('aria-pressed','false');
        b.setAttribute('aria-label','Add to wishlist');
        b.textContent='♡';
        w.appendChild(b);
      }
    });
    sync();
  }
  function schedule(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;enhance()});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('.nli-card-wishlist');
    if(!b)return;
    e.preventDefault();
    e.stopPropagation();
    var item={handle:b.dataset.handle,title:b.dataset.title,url:b.dataset.url,price:b.dataset.price};
    var list=read();
    var idx=list.findIndex(function(x){return k(x)===k(item)});
    if(idx>-1)list.splice(idx,1);else list.unshift(item);
    write(list);
    sync();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance,{once:true});else enhance();
  var root=document.querySelector('#MainContent')||document.body;
  if(root){
    var mo=new MutationObserver(schedule);
    mo.observe(root,{childList:true,subtree:true});
  }
})();